import { render, staticRenderFns } from "./InfoCircle.vue?vue&type=template&id=be7bba3e&"
import script from "./InfoCircle.vue?vue&type=script&setup=true&lang=js&"
export * from "./InfoCircle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InfoCircle.vue?vue&type=style&index=0&id=be7bba3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports